var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24559_9114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99203 1.33325C4.31203 1.33325 1.33203 4.31992 1.33203 7.99992C1.33203 11.6799 4.31203 14.6666 7.99203 14.6666C11.6787 14.6666 14.6654 11.6799 14.6654 7.99992C14.6654 4.31992 11.6787 1.33325 7.99203 1.33325ZM10.1454 11.5933L7.9987 10.2999L5.85203 11.5933C5.5987 11.7466 5.28536 11.5199 5.35203 11.2333L5.9187 8.79325L4.03203 7.15992C3.81203 6.96658 3.93203 6.59992 4.22536 6.57325L6.7187 6.35992L7.69203 4.05992C7.80536 3.78659 8.19203 3.78659 8.30536 4.05992L9.2787 6.35325L11.772 6.56659C12.0654 6.59325 12.1854 6.95992 11.9587 7.15325L10.072 8.78658L10.6387 11.2333C10.7054 11.5199 10.3987 11.7466 10.1454 11.5933Z",
    fill: "#70B46F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24559_9114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationIcon);
export default __webpack_public_path__ + "static/media/celebration-icon.7a225782.svg";
export { ForwardRef as ReactComponent };